import 'bootstrap';
import '@fortawesome/fontawesome';
import '@fortawesome/fontawesome-pro-solid';
import '@fortawesome/fontawesome-pro-regular';
import '@fortawesome/fontawesome-pro-light';
import '@fortawesome/fontawesome-free-brands';
import 'flexslider';
import 'jquery-match-height';
import './parts/site';
import './parts/turn';
import './parts/swiper';


//////////////////
// WEBPACK FOOTER
// ./assets/scripts/app.js
// module id = 4
// module chunks = 0